import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { manageFootballTeamService } from "../../../../../../../commons";
import { StatusEnum } from "../../../../../../../commons/enums/status-enum";

interface ISubTeamCoachRemoveState {
  manageSubTeamCoachRemoveStatus: StatusEnum;
}

const initialState: ISubTeamCoachRemoveState = {
  manageSubTeamCoachRemoveStatus: StatusEnum.Idle,
};

export interface ISubTeamCoachRemoveOption {
  teamId: number;
  subTeamId: number;
  coachId: number;
}

export const subTeamCoachRemove = createAsyncThunk(
  "manage/subTeamCoachRemove",
  async (options: ISubTeamCoachRemoveOption, thunkAPI) => {
    try {
      const subTeamCoachRemoveResponse = await manageFootballTeamService.removeSubTeamCoach(
        options.teamId,
        options.subTeamId,
        options.coachId
      );
      return subTeamCoachRemoveResponse;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const manageSubTeamCoachRemoveSlice = createSlice({
  name: "subTeamCoachRemove",
  initialState: initialState,
  reducers: {
    cleanUpSubTeamCoachRemove(state) {
      state.manageSubTeamCoachRemoveStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(subTeamCoachRemove.pending, (state) => {
        state.manageSubTeamCoachRemoveStatus = StatusEnum.Loading;
      })
      .addCase(subTeamCoachRemove.fulfilled, (state, action) => {
        state.manageSubTeamCoachRemoveStatus = StatusEnum.Succeeded;
      })
      .addCase(subTeamCoachRemove.rejected, (state) => {
        state.manageSubTeamCoachRemoveStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpSubTeamCoachRemove } = manageSubTeamCoachRemoveSlice.actions;
export default manageSubTeamCoachRemoveSlice.reducer;
